import React, { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom';
import commerce from '../../../lib/commerce';




const WebToken = () => {

  const [userToken, setUserToken] = useState('');
  let { slug } = useParams();
  let jwtToken = { slug }

  const jwt = () => {

    commerce.customer.getToken(jwtToken.slug)
      .then((jwt) => {
        setUserToken(jwt)

        // browserHistory.push("/profile");
      })
      .catch((err) => console.log('JWT ERROR: ', err))

  }

  useEffect(() => {
    jwt()
  }, []);

  if (userToken !== ''){
    return <Navigate to="/profile" replace={true} />
  }

  return (
    <div>WebToken</div>
  )
}

export default WebToken